/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AttachmentFileApiModel } from './attachmentFileApiModel';
import { OrderContentType } from './orderContentType';
import { AssessmentStatus } from './assessmentStatus';
import { AssessmentResult } from './assessmentResult';
import { AssessmentTypeEnum } from './assessmentTypeEnum';


export interface EmployeeReportApiModel { 
    id: number;
    orderDate?: string | null;
    issueDate: string;
    plannedDate?: string | null;
    createDate: string;
    number: string;
    status: AssessmentStatus;
    providerId?: number | null;
    providerName?: string | null;
    orderResultStatus: AssessmentResult;
    orderType: AssessmentTypeEnum;
    orderContentType: OrderContentType;
    employeeTitleBeforeName: string;
    employeeName: string;
    employeeSurname: string;
    employeeTitleAfterName: string;
    employeePersonalNumber: string;
    attachments: Array<AttachmentFileApiModel>;
}
export namespace EmployeeReportApiModel {
}


